import fetch from 'utils/fetch'
export function initProject (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/initProject`,
    method: 'post',
    data
  })
}
export function insertProject (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/insertProject`,
    method: 'post',
    data
  })
}
export function getOpenSourceProject (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/selectOpenSourceProjectList`,
    method: 'post',
    data
  })
}
export function getOpenSourceProjectCount (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/countProjectList`,
    method: 'post',
    data
  })
}
export function getProjectById (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/getProjectById`,
    method: 'post',
    data
  })
}
export function updateProject (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/updateProject`,
    method: 'post',
    data
  })
}
export function getProjectIdByUserId () {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/getProjectIdByUserId`,
    method: 'post'
  })
}

export function getProjectListAudit (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/selectProjectList`,
    method: 'post',
    data
  })
}
export function getProjectUserAndRole (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/getProjectUserAndRole`,
    method: 'post',
    data
  })
}
export function getProjectUserAndRoleCount (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/getProjectUserAndRoleCount`,
    method: 'post',
    data
  })
}
export function getProjectRoleCv (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/getProjectRoleCv`,
    method: 'post',
    data
  })
}
export function modifyProjectUserRole (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/modifyProjectUserRole`,
    method: 'post',
    data
  })
}
export function toAddProjectUserAndRole (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/createUserToProject`,
    method: 'post',
    data
  })
}
// 修改meta projcetName
export function modifyProjectNameInMeta (data) {
  return fetch({
    url: `/project/experiment/modifyProjectNameInMeta`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/project.js